const lists = {
    "languages_list":{
        "ro":"Română",
        "ru":"Русский",
    },
    "genders_list":{
        null:"Nu este indicat",
        "male":"Masculin",
        "female":"Feminin",
    }
};
export default lists